export const status = {
  PENDING: "PENDING",
  SENT: "SENT",
  RECEIVED: "RECEIVED",
  STARTED: "STARTED",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  ERROR_IOT: "ERROR_IOT",
  TIMEOUT_ACK: "TIMEOUT_ACK",
  TIMEOUT_EXEC: "TIMEOUT_EXEC",
};
